import { resolveRowAgainstEntry } from '../shape-map/resolver';
import { deriveUser } from './derive-user';
import { buildFields } from './build-fields';

export function formatAuditEntry({ row, rowEntry, predecessor, predecessorEntry, predecessorStatus }) {
  const resolved = resolveRowAgainstEntry(rowEntry, row);

  return {
    action: row.action,
    description: row.description,
    timestamp: row.timestamp,
    user: deriveUser(row),
    entity: rowEntry.entity ?? null,
    recordId: resolved.identity.recordId,
    recordKey: resolved.identity.recordKey,
    unattributed: resolved.unattributed,
    unattributedReason: resolved.unattributedReason,
    renderMode: resolved.renderMode,
    fields: buildFields({ row, rowEntry, predecessor, predecessorEntry, resolved, predecessorStatus }),
  };
}
